import { isIP } from "validator";

export function validate_ipAddress(data) {
    
    if( isIP(data) ) return true;

    return "txt151";

};
